const AudioCxt = (window as any).AudioContext || (window as any).webkitAudioContext;

const audioContext: AudioContext = new AudioCxt();

function decodeAudioDataPromise(arrayBuffer: ArrayBuffer): Promise<AudioBuffer> {
  return new Promise((resolve, reject) => {
    audioContext.decodeAudioData(
      arrayBuffer,
      decodedData => {
        resolve(decodedData);
      },
      error => {
        reject(error);
      }
    );
  });
}

export async function detectSilence(blob: Blob) {
  const decodedBuffer = await new Response(blob).arrayBuffer();

  const decodedData = await decodeAudioDataPromise(decodedBuffer);

  const channelData = decodedData.getChannelData(0);

  return channelData.every(value => {
    return value === 0;
  });
}
